import { call, put, takeEvery } from 'redux-saga/effects'
import * as paymentOrderActions from '../ducks/paymentOrderDucks'
import * as paymentOrderApi from '../../api/paymentOrderApi'

interface FetchRequestShareListSaga {
  type: string
  payload: string
}

interface FetchRequestShareDetailSaga {
  type: string
  payload: string
}

function* fetchListRequestShare({ payload: queryString }: FetchRequestShareListSaga) {
  try {
    const res: ReturnType<typeof paymentOrderApi.getListPaymentOrder> = yield call(paymentOrderApi.getListPaymentOrder, queryString)
    yield put(paymentOrderActions.getListPaymentOrderSuccess(res))
  } catch (error) {
    yield put(paymentOrderActions.getListPaymentOrderFail(error))
  }
}

function* fetchDetailRequestShare({ payload: id }: FetchRequestShareDetailSaga) {
  try {
    const res: ReturnType<typeof paymentOrderApi.getDetailPaymentOrder> = yield call(paymentOrderApi.getDetailPaymentOrder, id)
    yield put(paymentOrderActions.getDetailPaymentOrderSuccess(res))
  } catch (error) {
    yield put(paymentOrderActions.getDetailPaymentOrderFail(error))
  }
}

export default function* watchRequestShare() {
  yield takeEvery(paymentOrderActions.getListPaymentOrder.toString(), fetchListRequestShare)
  yield takeEvery(paymentOrderActions.getDetailPaymentOrder.toString(), fetchDetailRequestShare)
}
